export default {
      id: "other-meal2-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#other-meal2",
      toString: function () {
        return this.url;
      }
    }